import React from 'react';
import { NexsetStats } from 'new/elements/NexsetStats';

interface NexsetStatsTabProps {
  data: any;
}

export const NexsetStatsTab = (props: NexsetStatsTabProps) => {
  const { data } = props;
  return <NexsetStats resourceId={data.id} />;
};
